import React from 'react'
import cx from 'classnames'
import styles from './index.css'

const ImageArea = ({ className, style, src, children, ...rest }) => (
  <div
    className={cx(styles.imageWrap, className)}
    style={{
      ...style,
      ...(src ? { backgroundImage: `url(${src})` } : {}),
    }}
    {...rest}
  >
    {children}
  </div>
)

export default ImageArea



// WEBPACK FOOTER //
// ./src/components/ImageArea/index.js